const AMAZON_AWS_CODECOMMIT_HOST = "console.aws.amazon.com";
function readAwsCodeCommitIntegrationConfig(config) {
  var _a;
  const accessKeyId = config.getOptionalString("accessKeyId");
  const secretAccessKey = (_a = config.getOptionalString("secretAccessKey")) == null ? void 0 : _a.trim();
  const roleArn = config.getOptionalString("roleArn");
  const externalId = config.getOptionalString("externalId");
  const host = AMAZON_AWS_CODECOMMIT_HOST;
  return {
    host,
    accessKeyId,
    secretAccessKey,
    roleArn,
    externalId
  };
}
function readAwsCodeCommitIntegrationConfigs(configs) {
  const result = configs.map(readAwsCodeCommitIntegrationConfig);
  if (!result.some((c) => c.host === AMAZON_AWS_CODECOMMIT_HOST)) {
    result.push({
      host: AMAZON_AWS_CODECOMMIT_HOST
    });
  }
  return result;
}

export { readAwsCodeCommitIntegrationConfig, readAwsCodeCommitIntegrationConfigs };
//# sourceMappingURL=config.esm.js.map
